<template>
  <div id="classScoresPage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="نمرات کلاسی"></ActionBar>
    <div class="row container mx-auto p-0 mt-2">
      <div class="col-12 col-sm-10 col-md-6 col-lg-6 p-0 mb-4 mx-auto">
        <div class="member-ship-tab p-2 d-flex justify-space-between">
          <v-btn :class="{active: classScores}" class="px-8 px-sm-12 px-lg-16" color="third" rounded
                 @click="showClassScores"><span class="font12px">درسی</span>
          </v-btn>
          <v-btn :class="{active: weeklyScores}" class="px-8 px-sm-12 px-lg-16" color="third" rounded
                 @click="showWeeklyScores"><span class="font12px">میانگین هفتگی</span>
          </v-btn>
          <v-btn :class="{active: thermalScores}" class="px-8 px-sm-12 px-lg-16" color="third" rounded
                 @click="showThermalScores"><span class="font12px">ترمیک</span>
          </v-btn>
        </div>
      </div>
    </div>
    <div v-if="classScores">
      <div class="container mx-auto no-gutters  mt-2">
        <div class="row">
          <div class="col-6 col-md-4 col-lg-3">
            <div><i class="fas fa-calendar-check pl-1"></i><span class="font12px">از تاریخ:</span></div>
            <div>
              <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-left="100"
                  min-width="auto"
                  offset-y
                  transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="inputDate1"
                      v-bind="attrs"
                      v-on="on"
                      append-icon="mdi-calendar"
                      class="input-border"
                      color="forth"
                      dense
                      hide-details
                      readonly
                      solo></v-text-field>
                </template>
                <v-date-picker
                    v-model="date1"
                    color="forth"
                    locale="fa-ir"
                    width="256"
                    @input="inputDatePicker1"></v-date-picker>
              </v-menu>
            </div>
          </div>
          <div class="col-6 col-md-4 col-lg-3">
            <div><i class="fas fa-calendar-check pl-1"></i><span class="font12px">تا تاریخ:</span></div>
            <div>
              <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="auto"
                  offset-y
                  transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="inputDate2"
                      v-bind="attrs"
                      v-on="on"
                      append-icon="mdi-calendar"
                      class="input-border"
                      dense
                      hide-details
                      readonly
                      solo></v-text-field>
                </template>
                <v-date-picker
                    v-model="date2"
                    locale="fa-ir"
                    width="256"
                    @input="inputDatePicker2"></v-date-picker>
              </v-menu>
            </div>
          </div>
          <div class="col-8 col-sm-6 col-md-4 col-lg-3">
            <div><i class="fas fa-chalkboard-teacher pl-1"></i><span class="font12px">درس:</span></div>
            <v-autocomplete
                v-model="classId"
                :items="thermalScoreItem"
                class="input-border"
                color="white"
                dense
                hide-details
                item-text="Text"
                item-value="Value"
                solo></v-autocomplete>
          </div>
          <div class="col-4 col-sm-6 col-md-4 col-lg-3 align-self-end ">
            <v-btn color="forth" rounded><span class="white--text" @click="searchClassScores">جستجو</span></v-btn>
          </div>
        </div>
        <div v-if="dataLoading" class="col-12 mt-10 col-md-6 col-lg-3 mx-auto text-center">
          در حال جستجو
          <v-progress-linear
              color="deep-purple accent-4"
              height="6"
              indeterminate
              rounded
          ></v-progress-linear>
        </div>
        <div v-else-if="isLoaded">
          <div v-if="!hasData" class="mt-8">
            <v-alert
                border="bottom"
                class="mt-4 text-center"
                color="primary"
                dark>
              <span class="font12px">با توجه به موارد انتخاب شده موردی یافت نشد.</span>
            </v-alert>
          </div>
          <div v-else class="row no-gutters">
            <div class="col-12  rounded-b-lg header-rounded bg-white card-shadow mt-5">
              <div class="third-background header-rounded mb-3 white--text p-2 font16px">نمرات کلاسی دانش آموز</div>
              <div class="row no-gutters">
                <div v-for="(item,i) in classScoreItem" :key="i"
                     class="col-12  light-gray-bottom-border px-md-3  p-1 px-2">
                  <div class="row no-gutters">
                    <div class="col-5 mt-1"><span class="font12px gray-color ml-2">{{
                        $convertDate(item.ModifiedDate)
                      }}</span>
                    </div>
                    <div class="col-3 font12px text-right mt-1">
                      <div>{{ item.ClassType }}</div>
                    </div>
                    <div class="col-3 font12px text-right mt-1">
                      <div>{{ $roundNum(item.Avregae) }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="weeklyScores">

      <div class="row container mx-auto no-gutters p-0 mt-2">
        <div class="col-12 p-3">
          <div class="row">
            <div class="col-6 col-md-4 col-lg-3">
              <div><i class="fas fa-calendar-check pl-1"></i><span class="font12px">از تاریخ:</span></div>
              <div>
                <v-menu
                    v-model="weekStartDateModal"
                    :close-on-content-click="false"
                    :nudge-left="100"
                    min-width="auto"
                    offset-y
                    transition="scale-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="weekStartDateInput"
                        v-bind="attrs"
                        v-on="on"
                        append-icon="mdi-calendar"
                        class="input-border"
                        color="forth"
                        dense
                        hide-details
                        readonly
                        solo></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="weekStartDate"
                      color="forth"
                      locale="fa-ir"
                      width="256"
                      @input="weekInputStartDatePicker"></v-date-picker>
                </v-menu>
              </div>
            </div>
            <div class="col-6 col-md-4 col-lg-3">
              <div><i class="fas fa-calendar-check pl-1"></i><span class="font12px">تا تاریخ:</span></div>
              <div>
                <v-menu
                    v-model="weekEndDateModal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    min-width="auto"
                    offset-y
                    transition="scale-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="weekEndDateInput"
                        v-bind="attrs"
                        v-on="on"
                        append-icon="mdi-calendar"
                        class="input-border"
                        dense
                        hide-details
                        readonly
                        solo></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="weekEndDate"
                      locale="fa-ir"
                      width="256"
                      @input="weekInputEndDatePicker"></v-date-picker>
                </v-menu>
              </div>
            </div>
            <div class="col-4 col-sm-6 col-md-4 col-lg-3 align-self-end ">
              <v-btn color="forth" rounded><span class="white--text" @click="searchResult">جستجو</span></v-btn>
            </div>
          </div>
          <!--            <div class="col-8 col-sm-6 col-md-4 col-lg-3">
                        &lt;!&ndash;              <div><i class="fas fa-chalkboard-teacher pl-1"></i><span class="font12px">درس:</span></div>&ndash;&gt;
                        &lt;!&ndash;              <v-autocomplete&ndash;&gt;
                        &lt;!&ndash;                  v-model="classId"&ndash;&gt;
                        &lt;!&ndash;                  :items="thermalScoreItem"&ndash;&gt;
                        &lt;!&ndash;                  class="input-border"&ndash;&gt;
                        &lt;!&ndash;                  color="white"&ndash;&gt;
                        &lt;!&ndash;                  dense&ndash;&gt;
                        &lt;!&ndash;                  hide-details&ndash;&gt;
                        &lt;!&ndash;                  item-text="lesson"&ndash;&gt;
                        &lt;!&ndash;                  item-value="id"&ndash;&gt;
                        &lt;!&ndash;                  solo></v-autocomplete>&ndash;&gt;
                      </div>-->


        </div>
        <div v-if="dataWeekLoading" class="col-12 mt-10 col-md-6 col-lg-3 mx-auto text-center">
          در حال جستجو
          <v-progress-linear
              color="deep-purple accent-4"
              height="6"
              indeterminate
              rounded
          ></v-progress-linear>
        </div>
        <div v-else-if="isWeekLoaded" class="col-12">
          <div v-if="!hasWeekData" class="mt-8">
            <v-alert
                border="bottom"
                class="mt-4 text-center"
                color="primary"
                dark>
              <span class="font12px">با توجه به موارد انتخاب شده موردی یافت نشد.</span>
            </v-alert>
          </div>
          <div v-else class="row no-gutters">
            <div class="col-12 rounded-b-lg header-rounded bg-white card-shadow">
              <div class="third-background header-rounded mb-3 white--text p-2 font16px">نمرات کلاسی دانش آموز</div>
              <div class="row no-gutters">
                <div v-for="(item,i) in weekScoreItem" :key="i"
                     class="col-12  light-gray-bottom-border px-md-3 p-1 px-2">
                  <div class="row no-gutters">
<!--                    <div class="col-3 mt-1">{{ $convertDate(item.ModifiedDate) }}</div>-->
                    <div class="col-7 mt-1">{{ item.LeasonName }}</div>
                    <div class="col-4 font12px text-right mt-1">
                      <div>{{ $roundNum(item.Avregae) }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row py-3 px-2 no-gutters">
                <div class="col-9  font-weight-bold font16px"> میانگین نمرات :</div>
                <div class="col-3 text-right font-weight-bold font16px">{{ averageScores }}</div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
    <div v-if="thermalScores" >
      <div v-if="isWorkBooksLoaded" class="container">
        <div v-if="!hasWorkBook" class=" mx-2 mt-10 knowledge-base-body">
          <div class="col-12">
            <v-alert
                border="bottom"
                class="mt-4 text-center"
                color="forth"
                dark>
              شما کارنامه ای ندارید.
            </v-alert>
          </div>
        </div>
        <div v-else class="   mt-2">
            <div v-for="item in workBooks" :key="item.WorkBookID" class="col-12 col-md-6 mx-auto mb-10">
              <div class="rounded-b-lg header-rounded bg-white card-shadow">
                <div class="third-background header-rounded mb-3 white--text p-2 font16px text-center font-weight-bold">
                  {{ item.WorkBookName }}
                </div>
                <div class="row no-gutters">
                  <div v-for="answer  in item.Answers" :key="answer.Item1"
                       class="col-12  light-gray-bottom-border px-md-3  p-1 px-2">
                    <div class="row no-gutters">
                      <div class="col-9 mt-1"> {{ answer.Item3 }}
                      </div>
                      <div class="col-3 font12px text-right mt-1">
                        <div>{{ answer.Item2 }}</div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="row no-gutters mx-2">
                  <div class="col-9 mt-1 font-weight-bold"> میانگین
                  </div>
                  <div class="col-3 font12px text-right mt-1 font-weight-bold">
                    <div>{{ item.Average }}</div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
    <FooterMenu/>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ActionBar from "../components/ActionBar";
import FooterMenu from "../components/FooterMenu";
import moment from "moment-jalaali";

export default {
  name: "ClassScores",
  metaInfo: {
    title: 'مسیربرتر-نمرات کلاسی'
  },
  components: {FooterMenu, ActionBar},
  data: () => ({
    classId: null,
    averageScores: 0,
    classScores: true,
    isWorkBooksLoaded: false,
    isWeekLoaded: false,
    dataWeekLoading: false,
    hasWeekData: true,
    dataLoading: false,
    isLoaded: false,
    hasData: true,
    showLoaderDialog: false,
    hasWorkBook: true,
    weeklyScores: false,
    thermalScores: false,
    inputDate: '',
    date: new Date().toISOString().substr(0, 7),
    menu: false,
    classScoreItem: [],
    weekScoreItem: [],
    thermalScoreItem: [],
    inputDate1: '',
    inputDate2: '',
    menu1: false,
    date1: '',
    date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu2: false,
    weekEndDateModal: false,
    weekStartDateModal: false,
    weekStartDateInput: '',
    weekStartDate: '',
    weekEndDateInput: '',
    weekEndDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    workBooks: []
  }),
  mounted() {
    let current = new Date()
    current.setDate(current.getDate() - 30)
    this.inputDate2 = this.$convertDate(this.date2)
    this.date1 = current.toISOString().substr(0, 10)
    this.inputDate1 = this.$convertDate(this.date1)
    let current2 = new Date()
    current2.setDate(current2.getDate() - 7)
    this.weekStartDate = current2.toISOString().substr(0, 10)
    this.weekEndDateInput = this.$convertDate(this.weekEndDate)
    this.weekStartDateInput = this.$convertDate(this.weekStartDate)
    this.getWorkBookManagement()
    this.getLessons()
  },
  methods: {
    inputDatePicker1() {
      this.menu1 = false
      this.inputDate1 = moment(this.date1).format('jYYYY/jMM/jDD')
    },
    inputDatePicker2() {
      this.menu2 = false
      this.inputDate2 = moment(this.date2).format('jYYYY/jMM/jDD')
    },
    weekInputStartDatePicker() {
      this.weekStartDateModal = false
      this.weekStartDateInput = moment(this.weekStartDate).format('jYYYY/jMM/jDD')
    },
    weekInputEndDatePicker() {
      this.weekEndDateModal = false
      this.weekEndDateInput = moment(this.weekEndDate).format('jYYYY/jMM/jDD')
    },
    showClassScores() {
      this.classScores = true;
      this.weeklyScores = false;
      this.thermalScores = false;
    },
    showWeeklyScores() {
      this.classScores = false;
      this.weeklyScores = true;
      this.thermalScores = false;
    },
    showThermalScores() {
      this.classScores = false;
      this.weeklyScores = false;
      this.thermalScores = true;
    },
    inputDatePicker() {
      this.menu = false
      this.inputDate = moment(this.date).format('jYYYY/jM')
    },
    searchResult() {
      this.dataWeekLoading = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("StartDate", this.weekStartDateInput);
      urlencoded.append("EndDate", this.weekEndDateInput);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "PointManagement/_List", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)

            if (json.length > 0) {
              this.weekScoreItem = json
              this.hasWeekData = true
              let avg = 0
              for (let i = 0; i < json.length; i++) {
                avg += json[i].Avregae
              }
              this.averageScores = this.$roundNum(avg / json.length)

            } else {
              this.hasWeekData = false
            }
            this.dataWeekLoading = false
            this.isWeekLoaded = true
          })
          .catch(error => console.log('error', error));
    },
    getLessons() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);


      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "PointManagement/List", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            let classes = json.LessonsFuns
            this.thermalScoreItem = classes.filter(x => x.Disabled === false)
            this.classId = this.thermalScoreItem[0].Value
          })
          .catch(error => console.log('error', error));
    },
    searchClassScores() {


      this.dataLoading = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("StartDate", this.inputDate1);
      urlencoded.append("EndDate", this.inputDate2);
      urlencoded.append("LessonsFunID", this.classId);
      urlencoded.append("separateRecords","true");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "PointManagement/_List", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)

            if (json.length > 0) {
              this.classScoreItem = json
              this.hasData = true

            } else {
              this.hasData = false
            }
            this.dataLoading = false
            this.isLoaded = true
          })
          .catch(error => console.log('error', error));
    },
    getWorkBookManagement() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "WorkBookManagement/ListWorkBookStudentProfiles", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            if (json.length > 0) {
              this.workBooks = json
              this.isWorkBooksLoaded = true
            } else {
              this.isWorkBooksLoaded = true
              this.hasWorkBook = false
            }
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>
